module.exports = "<div id=\"main-content\" role=\"main\">\n    <div class=\"card\">\n        coucou\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/back-office-dashboard/back-office-dashboard.component.html
// module id = JSDE
// module chunks = 1